export const useDebugger = () => {
   const isDev = import.meta.dev;

   const log = (...message: any[]) => {
      if (isDev) {
         console.log(...message);
      }
   };
   const logWarn = (...message: any[]) => {
      if (isDev) {
         console.warn(...message);
      }
   };
   const logInfo = (...message: any[]) => {
      if (isDev) {
         console.info(...message);
      }
   };
   const logTrace = (...message: any[]) => {
      if (isDev) {
         console.trace(...message);
      }
   };
   const logError = (...message: any[]) => {
      // if (isDev) {
      console.error(...message);
      // }
   };
   const logTable = (...message: any[]) => {
      if (isDev) {
         console.table(...message);
      }
   };
   return {
      log,
      logInfo,
      logWarn,
      logTrace,
      logError,
      logTable,
   };
};
